import { createAction, props } from '@ngrx/store';
import { UserDictionary } from '../../models';

export const UsersUpdatedAction = createAction(
  '[Comment/Infrastructure] users updated',
  props<{ userDictionary: UserDictionary }>(),
);
